<template>
  <!-- {{ this.total_amount.toFixed(2) }}
     LKR {{ this.split_amount }} -->
  <div class="education">
    <div class="header-box">
      <div class="row">
        <div class="col-md-6 col-sm-12 mt-12">
          <div class="header_text">
            <h1 class="header-font">
              Find it. Like it.
            </h1>
            <h1 class="header-font2">Pay in 3</h1>
            <p class="header-content">
              Dont break the bank! Koko is a buy now pay later payment plaform
              which enables you to pay in 3 interest free instalments.
            </p>
            <div class="download_buttons_web">
              <div class="row mt-3">
                <div class="col" style="width: 200px;">
                  <a href="https://apps.apple.com/lk/app/koko-buy-now-pay-later/id1568237541">
                    <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/app-store-badge.png"
                      width="150" /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.sl.koko.bnpl">
                    <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/play-store-badge.png"
                      width="150" style="margin-left: 10px;" /></a>
                </div>
              </div>
            </div>
            <a class="download_buttons_mobile" href="https://bit.ly/merchantDownloadKoko">
              <button class="header-btn">
                Download
              </button>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 mt-12">
          <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/shutterstock_1835861686.jpg"
            alt="“hero”" class="header-banner" width="600" height="400" />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-2">
        <div class="col-md-12 col-sm-12 mt-12">
          <div class="row">
            <div class="col-md-12 col-sm-12 mt-12">
              <div class="header_text">
                <h1 v-show="this.$route.query.Amount">
                  <b style="color:#021FA3"> Rs.{{ final_total_amount }}</b>

                  Pay in 3 interest-free instalments with your debit card.
                </h1>
                <h1 v-show="!this.$route.query.Amount">
                  <b style="color:#021FA3"> </b>
                  Total bill value LKR 3000
                </h1>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-4 col-sm-12 mt-12">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pie1-4.png" alt="“hero”"
                style="height:150px;" />
              <div class="header_text">
                <h3>
                  <b style="color:#021FA3" v-if="this.isReadOnly"> Rs.{{ final_split_amount }}</b>
                  <b style="color:#021FA3" v-else> Rs.1000 </b>
                </h3>
                <h5>
                  DUE TODAY
                </h5>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 mt-12">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pie2.png" alt="“hero”"
                style="height:150px;" />
              <div class="header_text">
                <h3>
                  <b style="color:#021FA3" v-if="this.isReadOnly"> Rs.{{ final_split_amount }}</b>
                  <b style="color:#021FA3" v-else> Rs.1000 </b>
                </h3>
                <h5>
                  DUE IN 30 DAYS
                </h5>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 mt-12">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pie3.png" alt="“hero”"
                style="height:150px;" />
              <div class="header_text">
                <h3>
                  <b style="color:#021FA3" v-if="this.isReadOnly"> Rs.{{ final_split_amount }}</b>
                  <b style="color:#021FA3" v-else> Rs.1000 </b>
                </h3>
                <h5>
                  DUE IN 60 DAYS
                </h5>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 mt-12">
              <div class="header_text">
                <h1>
                  <b>Why use Koko?</b>
                </h1>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-md-4 col-sm-12 mt-12">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/QuickStart%20(2).png"
                alt="“hero”" style="height:150px;" />
              <div class="header_text">
                <h3>
                  <b> Pay how you like</b>
                </h3>
                <p>
                  Enjoy the convenience of getting what you want and paying for
                  it over time - even with your debit card!
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 mt-12">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/installments%20(2).png"
                alt="“hero”" style="height:150px;" />
              <div class="header_text">
                <h3>
                  <b> 3 interest-free payments</b>
                </h3>
                <p>
                  Pay in 3 with Koko through our app. Koko is accepted anywhere,
                  online and offline.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 mt-12">
              <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/Instant.png"
                alt="“hero”" style="height:150px;" />
              <div class="header_text">
                <h3>
                  <b> Instant Approval</b>
                </h3>
                <p>
                  Get instant approval to a spending limit that'll get you
                  started off quickly.
                </p>
              </div>
            </div>
          </div>

          <div class="row mt-1">
            <div class="col-md-12 col-sm-12 mt-12">
              <div class="get_started">
                <div class="header_text_2" style="margin-bottom: 5%">
                  <b>How to get started?</b>
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/img1.png"
                        alt="STEP 1" class="steps-img-step0" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 25%;">
                      STEP 1
                    </h1>
                    <h6 class="body-header-title3">
                      Download the app to shop your most-loved brands.
                    </h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 25%;">
                      STEP 2
                    </h1>
                    <h6 class="body-header-title3">
                      Shop online: View the instalments and choose Koko as your payment method.
                    </h6>
                  </div>
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/sdawdawda.png"
                        alt="STEP 2" class="steps-img-step7" />
                    </div>
                    <!-- <img
                      src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/deawdaw.png"
                      alt="“hero”"
                      style="height:100%;"
                    /> -->
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/dawdada.png"
                        alt="STEP 2" class="steps-img-step3" />
                    </div>

                  </div>
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 25%;">
                      STEP 3
                    </h1>
                    <h6 class="body-header-title3">
                      Shop in-store: Simply scan the QR code in-store, with your Koko app, and tap to pay.
                    </h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 25%;">
                      STEP 4
                    </h1>
                    <h6 class="body-header-title3">
                      Make the first of 3 payments now. Pay the rest over 60 days with 0% interest.
                    </h6>
                  </div>
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/dawdawda.png"
                        alt="STEP 2" class="steps-img-step4" />
                    </div>

                  </div>
                </div>
              </div>

              <div class="get_started2">
                <div class="header_text_2" style="margin-bottom: 5%">
                  <b>How to get started?</b>
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/img1.png"
                        alt="STEP 1" class="steps-img-step1" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 5%;">
                      STEP 1
                    </h1>
                    <h6 class="body-header-title3">
                      Download the app to shop your most-loved brands.
                    </h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/sdawdawda.png"
                        alt="STEP 2" class="steps-img-step7" />
                    </div>

                  </div>
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 5%;">
                      STEP 2
                    </h1>
                    <h6 class="body-header-title3">
                      Download the app to shop your most-loved brands.
                    </h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/dawdada.png"
                        alt="STEP 2" class="steps-img-step3" />
                    </div>

                  </div>
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 5%;">
                      STEP 3
                    </h1>
                    <h6 class="body-header-title3">
                      Download the app to shop your most-loved brands.
                    </h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 mt-12" style="background-color: #B5DEF0;">
                    <div class="grid grid-center">
                      <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/pdp/dawdawda.png"
                        alt="STEP 2" class="steps-img-step4" />
                    </div>

                  </div>
                  <div class="col-md-6 col-sm-12 mt-12">
                    <h1 class="body-header-title4" style="margin-top: 5%;">
                      STEP 4
                    </h1>
                    <h6 class="body-header-title3">
                      Download the app to shop your most-loved brands.
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="quiz">
            <div class="row">
              <div class="col-md-12 col-sm-12 mt-12">
                <div class="header_text">
                  <h1>
                    <b>Frequently Asked Questions</b>
                  </h1>
                </div>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-12 col-sm-12 mt-12">
                <div class="mt-1">
                  <vue-collapsible-panel-group base-color="#FFFFFF">
                    <vue-collapsible-panel :expanded="false">
                      <template #title>
                        <b class="faq-title">What is Koko?</b>
                      </template>
                      <template #content>
                        <p class="faq-body">
                          Koko is a buy now and pay later app that allows the
                          customers to pay in 3 equal instalments over 60 days
                          with 0% interest. No admin fees, mark-ups or hidden
                          charges!
                        </p>
                      </template>
                    </vue-collapsible-panel>
                  </vue-collapsible-panel-group>
                </div>
                <div class="mt-4">
                  <vue-collapsible-panel-group base-color="#FFFFFF">
                    <vue-collapsible-panel :expanded="false">
                      <template #title>
                        <b class="faq-title">
                          I am a customer, what happens if I can’t pay on time?
                        </b>
                      </template>
                      <template #content>
                        <p class="faq-body">
                          If we are unable to collect payment on the scheduled
                          day from the provided card, we will try again in 2
                          days and other cards connected to your account will
                          also be checked. If the payment is unsuccessful after
                          a second attempt, a flat late fee of Rs. 1500 will be
                          added to your outstanding balance and will have to be
                          paid with the installment due. Missed payments and
                          late payment fees will be added to the total of the
                          next scheduled payment. To keep you in the loop, we’ll
                          send you an email and message notifications if your
                          payment was unsuccessful. Please keep in mind if a
                          single installment payment remains unpaid you will be
                          temporarily suspended from using our payment options
                          in the future, till the dues are settled. If dues are
                          not paid for a period of four months, the customer
                          will be identified as in default and the customer's
                          account will be permanently disabled.
                        </p>
                      </template>
                    </vue-collapsible-panel>
                  </vue-collapsible-panel-group>
                </div>

                <div class="mt-4">
                  <vue-collapsible-panel-group base-color="#FFFFFF">
                    <vue-collapsible-panel :expanded="false">
                      <template #title>
                        <b class="faq-title">How will I receive my full refund?</b>
                      </template>
                      <template #content>
                        <p class="faq-body">
                          We would like to inform you that the customer has to
                          apply for a refund through the merchant portal. Kindly
                          contact the merchant regarding this and request to
                          initiate a refund from their end. Once the merchant
                          has initiated a Refund, we will process the refund
                          amount back to your card (credit or debit) which has
                          been used as the payment method. If you have any
                          refunds, it will appear in Koko purchases tab under
                          the refunded section.
                        </p>
                      </template>
                    </vue-collapsible-panel>
                  </vue-collapsible-panel-group>
                </div>

                <div class="mt-4">
                  <vue-collapsible-panel-group base-color="#FFFFFF">
                    <vue-collapsible-panel :expanded="false">
                      <template #title>
                        <b class="faq-title">How much am I eligible to spend?</b>
                      </template>
                      <template #content>
                        <p class="faq-body">
                          To ensure safe spending practices, each new purchase
                          is evaluated by our system to determine approval. This
                          takes into account many different factors including
                          time of day, size of the purchase, and any history
                          with Koko. The longer you have been using the in-app
                          shopping feature and the more orders you have
                          successfully repaid, the more likely you will be able
                          to spend more. Restrictions are tighter for ‘new’
                          shoppers until we get to know you.
                        </p>
                      </template>
                    </vue-collapsible-panel>
                  </vue-collapsible-panel-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from "@dafcoe/vue-collapsible-panel";
import "@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css";
export default {
  name: "EducationalView",
  components: { VueCollapsiblePanelGroup, VueCollapsiblePanel },
  props: {},
  data() {
    return {
      split_amount: "",
      total_amount: "",
      playAmount: "",
      isReadOnly: true
    };
  },
  computed: {
    itemPrice() {
      return (
        Math.round((this.playAmount / 3) * 100) / 100
      )
    }
  },
  created() {

    let Amount = "";

    if (this.$route.query.Amount) {
      Amount = this.$route.query.Amount.replace(/[^\d.]+/g, '');

      console.log("final_split_amount --- ", Amount);

      this.split_amount = Amount;
      this.total_amount = this.split_amount * 3;

      var split_val = Math.round(this.split_amount * 100) / 100;
      var total_val = Math.round(this.total_amount * 100) / 100;

      this.final_total_amount = total_val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      this.final_split_amount = split_val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // console.log("final_split_amount --- ", this.final_split_amount);
      // console.log("Final Total Amount --- ", this.final_total_amount);
    } else {
      this.isReadOnly = false;
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.faq-title {
  font-family: "Raleway";
  font-size: 20px;
  text-align: left;
}
.faq-body {
  font-size: 14px;
  font-family: "Raleway";
  font-weight: 400;
  text-align: justify;
}
.steps-img-step4 {
  height: 350px;
  margin-bottom: 10%;
}
.steps-img-step3 {
  height: 250px;
  margin-top: 23%;
}
.steps-img-step2 {
  height: 350px;
  margin-bottom: 10%;
}
.steps-img-step1 {
  height: 350px;
  margin-bottom: 10%;
}
.grid {
  display: grid;
  background-color: #b5def0;
}
.grid.grid-center {
  justify-content: center;
  align-items: center;
}
.education {
  margin-bottom: 10%;
}
.body-header-title3 {
  text-align: center;
  font-family: "Raleway";
  font-weight: 900;
}
.body-header-title4 {
  text-align: center;
  font-family: "Raleway";
  font-weight: 900;
  font-size: 18px;
  margin-top: 1%;
}
.header-banner {
  width: 100%;
  max-width: 1000px;
  height: auto;
}
.header-box {
  background-color: #b5def0;
  height: auto;
}
.header-btn {
  float: left;
  margin: 5%;
  background: #0217a3;
  border-radius: 25px;
  border: none;
  color: white;
  font-family: "Raleway";
  /* margin-left: 2%; */
  /* margin-top: 2%; */
  height: 60px;
  width: 150px;
}
.header-content {
  text-align: left;
  font-family: "Raleway";
  margin-left: 5%;
  font-weight: 600;
  font-size: 20px;
}
.header-font {
  color: #0217a3;

  font-family: "Raleway";
  margin-left: 5%;
  font-weight: 800;
  font-size: 75px;
  text-align: left;
}

.header-font2 {
  color: white;
  font-family: "Raleway";
  margin-left: 5%;
  font-weight: 800;
  font-size: 75px;
  text-align: left;
}
.image {
  text-align: left;
  margin-left: 0%;
  margin-top: -10%;
}
.get_started {
  height: auto;
  border-radius: 20px;
  /* margin: 10%; */
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 3%;
}
.header_text_2 {
  font-family: Raleway;
  color: black;
  margin-top: 6%;
  font-weight: 600;
  margin-left: 2%;
  margin-right: 2%;
  font-size: 40px;
}
.header_text_3 {
  font-family: Raleway;
  color: black;
  margin-top: 2%;
  margin-left: 5%;
  margin-right: 5%;
}
.bodytext {
  font-family: Raleway;
  color: black;
}
.bodytext2 {
  font-family: Raleway;
  color: black;
}
.header_text {
  color: black;
  text-align: center;
  margin: 5%;
  font-family: Raleway;
}
.header_body {
  text-align: center;
  background-color: white;
  border-radius: 40px;
  margin-bottom: 5%;
}

.body_class {
  background-color: white;
}
.div#app {
  background-color: white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 56px;

  color: #393939;
}

.heroline2 {
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;
  text-align: justify;
  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}
.sectionKoko2 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.stepHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

.bigSpecImgHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  /* line-height: 29px; */

  color: #393939;
}

.zcwf_col_lab {
  color: #393939;
  opacity: 0.8;
}

.maxWidthDefiner {
  /*max-width: 250px;*/
  margin-top: 30px;
}

.maxWidthDefiner3 {
  max-width: 300px;
  margin-top: 30px;
}

.kokoWebButtons {
  background-color: #000000;
  border: 0;
  height: 40px;
  width: 300px;
  font-weight: bold;
}

.headerbox {
  background-color: white;
  border-radius: 16px;
  width: 90%;
  margin-left: 5%;
  height: 300px;
  margin-top: 5%;
}
.headerbox_body {
  margin-left: 5%;
  padding-top: 5%;
  height: 450px;
  margin-right: 5%;
}
.mobile {
  display: none;
}
.header_imge {
  max-width: 137%;
  margin-top: -24%;
  margin-left: -70%;
}
.get_started2 {
  display: none;
}
.get_started {
  display: block;
}

.steps-img-step7 {
  height: 300px;
  margin-bottom: 0%;
  margin-top: 10%;
}
.steps-img-step0 {
  height: 400px;
}
.download_buttons_mobile {
  display: none;
}
.download_buttons_web {
  margin-top: 5%;
  text-align: left;
  margin-left: 5%;
}
/* Collapse Css */

@media only screen and (max-width: 600px) {
  .headerbox {
    background-color: white;
    border-radius: 16px;
    width: 90%;
    margin-left: 5%;
    height: 330px;
  }
  .mobile {
    display: block;
  }

  .pc {
    display: none;
  }
  .header_imge {
    max-width: 100%;
    margin-top: -10%;
    margin-left: -6%;
  }
  .get_started {
    display: none;
  }
  .get_started2 {
    display: block;
  }
  .koko-charactor {
    display: none;
  }
  .header-content {
    text-align: left;
    font-family: "Raleway";
    margin-left: 5%;
    font-weight: 600;
    font-size: 15px;
  }
  .header-font {
    color: #021699;
    font-family: "Raleway";
    margin-left: 5%;
    font-weight: 800;
    font-size: 50px;
    text-align: left;
  }

  .header-font2 {
    color: #ffffff;
    font-family: "Raleway";
    margin-left: 5%;
    font-weight: 800;
    font-size: 50px;
    text-align: left;
  }
  .education {
    margin-bottom: 20%;
  }
  .steps-img-step1 {
    margin-bottom: 0%;
  }
  .steps-img-step7 {
    height: 300px;
    margin-bottom: 0%;
    margin-top: 10%;
  }
  .faq-title {
    font-family: "Raleway";
    font-size: 15px;
    text-align: left;
  }

  .header-btn {
    float: left;
    margin: 5%;
    background: #0217a3;
    border-radius: 15px;
    border: none;
    color: white;
    font-family: "Raleway";
    height: 45px;
    width: 120px;
  }
  .header_text {
    color: black;
    text-align: center;
    margin: 4%;
    font-family: Raleway;
  }
  .download_buttons_web {
    display: none;
  }
  .download_buttons_mobile{
    display: block;
  }
}
</style>
